/* 生活相談ページのバナー動画：再生／停止、位置を選ぶバー、音のON/OFF、拡大表示 */
(function () {
  function safePlay(v) { var p = v.play && v.play(); if (p && p.catch) p.catch(function () {}); }
  document.querySelectorAll('.lp-soudan-video').forEach(function (box) {
    var v = box.querySelector('video');
    if (!v) return;
    v.muted = true;
    safePlay(v);

    /* 音のON/OFF */
    var b = box.querySelector('.lp-soudan-video__sound');
    if (b) b.addEventListener('click', function () {
      v.muted = !v.muted;
      if (!v.muted) safePlay(v);
      b.setAttribute('aria-pressed', String(!v.muted));
      b.setAttribute('aria-label', v.muted ? '音を出す' : '音を消す');
      b.querySelector('.lp-soudan-video__label').textContent = v.muted ? 'ON' : 'OFF';
    });

    /* 再生／停止 */
    var pb = box.querySelector('.lp-soudan-video__play');
    function syncPlay() {
      if (!pb) return;
      pb.setAttribute('aria-pressed', String(!v.paused));
      pb.setAttribute('aria-label', v.paused ? '動画を再生する' : '動画を止める');
    }
    if (pb) pb.addEventListener('click', function () { if (v.paused) safePlay(v); else v.pause(); });
    v.addEventListener('play', syncPlay);
    v.addEventListener('pause', syncPlay);
    syncPlay();

    /* 位置を選ぶバー：再生ボタンと音のボタンのあいだ。つまみを動かすと、その場面に移動 */
    var ctrl = box.querySelector('.lp-soudan-video__ctrl');
    if (ctrl && !ctrl.querySelector('.lp-soudan-video__seek')) {
      var wrap = document.createElement('div');
      wrap.className = 'lp-soudan-video__seek';
      var r = document.createElement('input');
      r.type = 'range'; r.min = '0'; r.max = '1000'; r.step = '1'; r.value = '0';
      r.setAttribute('aria-label', '動画の位置');
      wrap.appendChild(r);
      ctrl.insertBefore(wrap, b || null);
      var dragging = false;
      function paint() {
        var pct = (r.value / 10) + '%';
        r.style.setProperty('--lp-sv-pct', pct);
      }
      function sync() {
        if (dragging || !v.duration) return;
        r.value = Math.round(v.currentTime / v.duration * 1000);
        paint();
      }
      function tick() { sync(); if (!v.paused) requestAnimationFrame(tick); }
      v.addEventListener('timeupdate', sync);
      v.addEventListener('play', function () { requestAnimationFrame(tick); });
      v.addEventListener('loadedmetadata', sync);
      r.addEventListener('input', function () {
        dragging = true;
        if (v.duration) v.currentTime = r.value / 1000 * v.duration;
        paint();
      });
      r.addEventListener('change', function () { dragging = false; sync(); });
      r.addEventListener('pointerup', function () { dragging = false; });
      r.addEventListener('touchend', function () { dragging = false; });
      paint();
      if (!v.paused) requestAnimationFrame(tick);
    }

    /* 拡大表示（パソコン・スマホとも）（右上のボタン、または動画をタップ）。黒い背景の上に大きく出し、「閉じる」・背景のタップ・Escキーで元に戻す */
    var zb = box.querySelector('.lp-soudan-video__zoom');
    var overlay = null, ph = null;
    function open() {
      if (overlay) return;
      var rect = box.getBoundingClientRect(), cs = getComputedStyle(box);
      ph = document.createElement('div');
      ph.style.cssText = 'width:' + rect.width + 'px;height:' + rect.height + 'px;margin:' + cs.margin + ';max-width:100%';
      ph.style.gridColumn = cs.gridColumn; ph.style.gridRow = cs.gridRow; ph.style.alignSelf = cs.alignSelf; ph.style.justifySelf = cs.justifySelf;
      box.parentNode.insertBefore(ph, box);
      overlay = document.createElement('div');
      overlay.className = 'lp-sv-overlay';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-label', '動画の拡大表示');
      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'lp-sv-overlay__close';
      close.innerHTML = "<svg viewBox='0 0 24 24' aria-hidden='true'><path d='M6 6l12 12M18 6L6 18' fill='none' stroke='currentColor' stroke-width='3' stroke-linecap='round'/></svg>閉じる";
      close.addEventListener('click', shut);
      overlay.appendChild(close);
      overlay.appendChild(box);
      overlay.addEventListener('click', function (e) { if (e.target === overlay) shut(); });
      document.body.appendChild(overlay);
      document.documentElement.classList.add('lp-sv-lock');
      safePlay(v);
      close.focus();
    }
    function shut() {
      if (!overlay) return;
      ph.parentNode.insertBefore(box, ph);
      ph.remove(); overlay.remove();
      overlay = null; ph = null;
      document.documentElement.classList.remove('lp-sv-lock');
      if (zb) zb.focus();
    }
    if (zb) zb.addEventListener('click', open);
    v.addEventListener('click', function () { if (!overlay) open(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') shut(); });
  });
})();
